/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Employee,
} from '../models/index';
import {
    EmployeeFromJSON,
    EmployeeToJSON,
} from '../models/index';

/**
 * 
 */
export class EmployeeApi extends runtime.BaseAPI {

    /**
     * Creates request options for getEmployees without sending the request
     */
    async getEmployeesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/internal/employees`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns non-technical employees for dropdowns, sorted by last name.
     * Return bank employees
     */
    async getEmployeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Employee>>> {
        const requestOptions = await this.getEmployeesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmployeeFromJSON));
    }

    /**
     * Returns non-technical employees for dropdowns, sorted by last name.
     * Return bank employees
     */
    async getEmployees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Employee>> {
        const response = await this.getEmployeesRaw(initOverrides);
        return await response.value();
    }

}
